import styles from "../css/ecoControlFridges.module.css";
import Navbar from "../../../../components/navbar";
import Footer from "../../../../components/footer";
import Button from "../../../../components/Button";
import Pagination from "../../../../components/Pagination";
import FilterButtons from "../../../../components/universal-filter-tabs";
import { useEffect, useState } from "react";
import { useAuth } from "../../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { fridgeData, fridgeContentsData, defaultFridgeValues } from "../data/fridgeData";
import AddFridgeForm from "./AddFridgeForm";
import FridgeGrid from "./FridgeGrid";
import FridgeDetailsModal from "./FridgeDetailsModal";
import FridgeContentsModal from "./FridgeContentsModal";

export default function FridgesPage() {
  const { user } = useAuth();
  const roleId = Number(user?.roleid);
  const navigate = useNavigate();
  
  const [ui, setUi] = useState({ currentPage: 1, showAddFridge: false, showDetails: false, showContents: false, contentsPage: 1, detailsEdit: false, contentsEdit: false });
  const [selectedFridge, setSelectedFridge] = useState(null);
  const [details, setDetails] = useState({ bin: "", temp: "", totalQty: "", supplier: "", serial: "" });
  const [filters, setFilters] = useState({ detailsRange: 'Day', detailsWeekday: 'Monday', contentsCategory: '' });
  const [contentsRows, setContentsRows] = useState(fridgeContentsData);
  const [cFields, setCFields] = useState({ itemName: "", sku: "", batch: "", qty: 10, unity: "", expiry: null });
  const [activeTab, setActiveTab] = useState("Fridges");

  const tabs = ["Sensors", "Fridges"];

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    
    // Navigate to the appropriate route
    if (tab === "Sensors") {
      navigate("/inventory/eco-control-sensors");
    } else {
      navigate("/inventory/eco-control-fridges");
    }
  };
  const [addForm, setAddForm] = useState({
    binNumber: defaultFridgeValues.binNumber,
    temperature: defaultFridgeValues.temperature,
    serialNumber: defaultFridgeValues.serialNumber,
    supplier: defaultFridgeValues.supplier,
    totalQty: defaultFridgeValues.totalQty,
    uploadFile: defaultFridgeValues.uploadFile,
    itemName: defaultFridgeValues.itemName,
    sku: defaultFridgeValues.sku,
    batch: defaultFridgeValues.batch,
    qty: defaultFridgeValues.qty,
    unity: defaultFridgeValues.unity,
    expiry: defaultFridgeValues.expiry,
  });

  const fridges = fridgeData;
  const pageSize = 4;
  const totalPages = Math.max(1, Math.ceil(fridges.length / pageSize));
  const startIndex = (ui.currentPage - 1) * pageSize;
  const visibleFridges = fridges.slice(startIndex, startIndex + pageSize);

  useEffect(() => {
    if (ui.showDetails && selectedFridge) {
      setDetails({ bin: (selectedFridge.bin || "Bin 001").replace("Bin ", ""), temp: "2", totalQty: "150", supplier: "Global Meds Inc.", serial: "02589630147800" });
      setUi((s)=>({ ...s, detailsEdit: false }));
    }
  }, [ui.showDetails, selectedFridge]);

  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.dashboardLayout}>
        <main className={styles.main}>
          <div className={styles.container}>
            {/* Filter Tabs - Only show to Director (role ID 2) */}
            {roleId === 2 && (
              <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '0.5rem' }}>
                <FilterButtons
                  buttons={tabs}
                  activeButton={activeTab}
                  onButtonClick={handleTabClick}
                />
              </div>
            )}
            
            <section className={styles.section}>
              <div className={`${styles.headerRow} ${styles.flexEndRow}`}>
                {!ui.showAddFridge && (
                  <Button variant="primary" onClick={() => setUi((s)=>({ ...s, showAddFridge: true }))}>+ Add Fridge</Button>
                )}
              </div>
              <AddFridgeForm
                showAddFridge={ui.showAddFridge}
                binNumber={addForm.binNumber}
                temperature={addForm.temperature}
                serialNumber={addForm.serialNumber}
                supplier={addForm.supplier}
                totalQty={addForm.totalQty}
                uploadFile={addForm.uploadFile}
                itemName={addForm.itemName}
                sku={addForm.sku}
                batch={addForm.batch}
                qty={addForm.qty}
                unity={addForm.unity}
                expiry={addForm.expiry}
                roleId={roleId}
                onBinNumberChange={(e)=>setAddForm({...addForm, binNumber: e.target.value})}
                onTemperatureChange={(e)=>setAddForm({...addForm, temperature: e.target.value})}
                onSerialNumberChange={(e)=>setAddForm({...addForm, serialNumber: e.target.value})}
                onSupplierChange={(val)=>setAddForm({...addForm, supplier: val})}
                onTotalQtyChange={(val)=>setAddForm({...addForm, totalQty: val})}
                onUploadFileChange={(e)=>setAddForm({...addForm, uploadFile: e.target.files?.[0] || null})}
                onItemNameChange={(e)=>setAddForm({...addForm, itemName: e.target.value})}
                onSkuChange={(e)=>setAddForm({...addForm, sku: e.target.value})}
                onBatchChange={(e)=>setAddForm({...addForm, batch: e.target.value})}
                onQtyChange={(val)=>setAddForm({...addForm, qty: val})}
                onUnityChange={(val)=>setAddForm({...addForm, unity: val})}
                onExpiryChange={(val)=>setAddForm({...addForm, expiry: val})}
                onCancel={()=> setUi((s)=>({ ...s, showAddFridge: false }))}
                onAddToFridge={()=>{}}
              />
              {!ui.showAddFridge && (
                <FridgeGrid
                  fridges={fridges}
                  visibleFridges={visibleFridges}
                  onDetailsClick={(f)=>{ setSelectedFridge(f); setUi((s)=>({ ...s, showDetails: true })); }}
                  onContentsClick={(f)=>{ setSelectedFridge(f); setUi((s)=>({ ...s, showContents: true })); }}
                />
              )}
              {(!ui.showAddFridge && totalPages > 1) && (
                <div className={styles.pagerRow}>
                  <Pagination
                    currentPage={ui.currentPage}
                    totalPages={totalPages}
                    onPageChange={(p) => setUi((s)=>({ ...s, currentPage: p }))}
                  />
                </div>
              )}
            </section>
            <FridgeDetailsModal
              showDetails={ui.showDetails}
              selectedFridge={selectedFridge}
              detailsEdit={ui.detailsEdit}
              dBin={details.bin}
              dTemp={details.temp}
              dTotalQty={details.totalQty}
              dSupplier={details.supplier}
              dSerial={details.serial}
              detailsRange={filters.detailsRange}
              detailsWeekday={filters.detailsWeekday}
              onClose={()=> setUi((s)=>({ ...s, showDetails: false, detailsEdit: false }))}
              onEdit={()=> setUi((s)=>({ ...s, detailsEdit: true }))}
              onSave={()=> { setSelectedFridge((prev)=> prev ? ({ ...prev, bin: `Bin ${details.bin}` }) : prev); setUi((s)=>({ ...s, detailsEdit: false })); }}
              onCancel={()=> { setDetails({ bin: (selectedFridge?.bin || 'Bin 001').replace('Bin ','') , temp:'2', totalQty:'150', supplier:'Global Meds Inc.', serial:'02589630147800' }); setUi((s)=>({ ...s, detailsEdit: false })); }}
              onBinChange={(e)=> setDetails((d)=>({ ...d, bin: e.target.value }))}
              onTempChange={(e)=> setDetails((d)=>({ ...d, temp: e.target.value }))}
              onTotalQtyChange={(e)=> setDetails((d)=>({ ...d, totalQty: e.target.value }))}
              onSupplierChange={(e)=> setDetails((d)=>({ ...d, supplier: e.target.value }))}
              onSerialChange={(e)=> setDetails((d)=>({ ...d, serial: e.target.value }))}
              onRangeChange={(val)=> setFilters((f)=>({ ...f, detailsRange: val }))}
              onWeekdayChange={(val)=> setFilters((f)=>({ ...f, detailsWeekday: val }))}
              onReset={()=> setDetails({ bin: (selectedFridge?.bin || 'Bin 001').replace('Bin ','') , temp:'2', totalQty:'150', supplier:'Global Meds Inc.', serial:'02589630147800' })}
            />
            <FridgeContentsModal
              showContents={ui.showContents}
              selectedFridge={selectedFridge}
              contentsRows={contentsRows}
              contentsPage={ui.contentsPage}
              contentsEdit={ui.contentsEdit}
              cItemName={cFields.itemName}
              cSku={cFields.sku}
              cBatch={cFields.batch}
              cQty={cFields.qty}
              cUnity={cFields.unity}
              cExpiry={cFields.expiry}
              contentsCategory={filters.contentsCategory}
              roleId={roleId}
              onClose={()=> setUi((s)=>({ ...s, showContents: false, contentsEdit: false }))}
              onContentsPageChange={(p)=> setUi((s)=>({ ...s, contentsPage: p }))}
              onEdit={()=> setUi((s)=>({ ...s, contentsEdit: true }))}
              onSave={()=> setUi((s)=>({ ...s, contentsEdit: false }))}
              onItemNameChange={(e)=> setCFields((c)=>({ ...c, itemName: e.target.value }))}
              onSkuChange={(e)=> setCFields((c)=>({ ...c, sku: e.target.value }))}
              onBatchChange={(e)=> setCFields((c)=>({ ...c, batch: e.target.value }))}
              onQtyChange={(val)=> setCFields((c)=>({ ...c, qty: val }))}
              onUnityChange={(val)=> setCFields((c)=>({ ...c, unity: val }))}
              onExpiryChange={(val)=> setCFields((c)=>({ ...c, expiry: val }))}
              onCategoryChange={(val)=> setFilters((f)=>({ ...f, contentsCategory: val }))}
              onRemoveItem={(id)=> setContentsRows((rows)=> rows.filter(r=> r.id !== id))}
            />
          </div>
        </main>
      </div>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}
